import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {AlertModal, ModalButtons} from 'shared/components/modals';

const MissingDimensionsModal = observer(({uiState, isOpen}) => {
  return (
    <AlertModal
      isOpen={isOpen}
      onHide={() => uiState.closeMissingDimensionsModal()}
      header='time_tracking.shifts.Shift Cannot Be Assigned'
    >
      {uiState.missingAssignments.map(({employee, missingValues}) => (
        <div key={employee.id} className='mb2'>
          <div className='jumbo mb1'>
            <FormattedMessage id='time_tracking.shifts.MISSING_DIMENSION_VALUES' values={{name: employee.name}}/>
          </div>
          <ul className='ShiftGrid-missingValues'>
            {missingValues.map(({value, dimension}) => (
              <li key={value.id}>
                <FormattedMessage
                  id='time_tracking.shifts.DIMENSION_VALUE'
                  values={{dimension: <span key='dimension' className='medium'>{dimension.name}</span>, value: value.name}}
                />
              </li>
            ))}
          </ul>
        </div>
      ))}
      <ModalButtons hideSave cancelCaption='time_tracking.shifts.Close' onCancel={() => uiState.closeMissingDimensionsModal()}/>
    </AlertModal>
  );
});

export default MissingDimensionsModal;
